export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14302.8adfe3ee.jpg";